<template>
  <a-modal
    title="放款信息"
    v-model="modalShow"
    width="600px"
    :footer="false"
    @cancel="close"
    destroyOnClose>
    <div style="margin-top:-20px;">
      <a-form-model
        :model="pageData"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="银行融资流水号：" prop="loanApplyNo" class="loaned-item">
          {{pageData.loanApplyNo}}
        </a-form-model-item>
        <!-- <a-form-model-item label="借据编号：" prop="vchno" class="loaned-item">
          {{pageData.vchno}}
        </a-form-model-item> -->
        <a-form-model-item label="融资企业：" prop="entName" class="loaned-item">
          {{pageData.entName}}
        </a-form-model-item>
        <a-form-model-item label="融资金额：" prop="amount" class="loaned-item">
          {{pageData.amount | splitK}} 元
        </a-form-model-item>
        <a-form-model-item label="放款日期：" prop="startDate" class="loaned-item">
          {{moment(pageData.startDate).format("YYYY-MM-DD")}}
        </a-form-model-item>
        <a-form-model-item label="到期日期：" prop="loanEndDate" class="loaned-item">
          {{moment(pageData.loanEndDate).format("YYYY-MM-DD")}}
        </a-form-model-item>
        <a-form-model-item label="融资利率：" prop="execRate" class="loaned-item">
          {{pageData.execRate}} %
        </a-form-model-item>
        <a-form-model-item label="融资利息：" prop="interest" class="loaned-item">
          {{pageData.interest | splitK}} 元
        </a-form-model-item>
        <a-form-model-item label="银行手续费率：" prop="factFeeRate" class="loaned-item">
          {{pageData.factFeeRate}} %
        </a-form-model-item>
        <a-form-model-item label="银行手续费：" prop="factFee" class="loaned-item">
          {{pageData.factFee | splitK}} 元
        </a-form-model-item>
        <a-form-model-item label="平台服务费率：" prop="factFeeRate" class="loaned-item">
          {{pageData.platformRate}} %
        </a-form-model-item>
        <a-form-model-item label="平台服务费：" prop="factFee" class="loaned-item">
          {{pageData.platformFee | splitK}} 元
        </a-form-model-item>
        <a-form-model-item label="收款账号：" prop="recvAcc" class="loaned-item">
          {{pageData.recvAcc || '--'}}
        </a-form-model-item>
        <a-form-model-item label="开户银行：" prop="repayBankName" class="loaned-item">
          {{pageData.repayBankName || '--'}}
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import { fncDetailsApi } from "@/api/borrow.js"
export default {
    name:"goldFinancingDetail",
    data() {
        return {
            modalShow:false,
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
            pageData:{
              jrnNo:undefined,
              entName:undefined,
              amount:undefined,
              startDate:undefined,
              loanEndDate:undefined,
              execRate:undefined,
              interest:undefined,
              factFeeRate:undefined,
              factFee:undefined,
              recvAcc:undefined,
              repayBankName:undefined,
              businessNo:undefined
            }
        };
    },
    methods: {
        open(data){
            this.getDetail(data);
            this.modalShow = true;
        },
        close(){
            this.modalShow = false;
        },
        getDetail(data){ //融资申请点击查看祺信详情
          fncDetailsApi(data.fncJrnlId).then(res => {
            this.pageData = res.data;
          })
        }
    }
};
</script>
<style scoped>
.loaned-item{
  margin-bottom:4px;
}
</style>



// WEBPACK FOOTER //
// src/pages/circulation/gold-financing/loanedDetailDialog.vue